<div class="border-b border-gray-200 max-w-[500px]">
	<h2 class="h2 pb-3">View And Sync Docket?</h2>
</div>
<p class="p py-8 max-w-[350px]">
	Would you like to view and sync your docket now?
</p>
<ui-content-footer
	[primaryAction]="{
		text: 'View and Sync',
		action: showDocketSummary,
		icon: 'eye-share',
	}"
	[secondaryAction]="{ text: 'Skip', action: skip }"
	hideBorder
	noPadding
	teranetLoginGuard
	[testHook]="testHooks.ContentFooter"
>
</ui-content-footer>
